import {observe} from '@github-ui/selector-observer'
import {on} from 'delegated-events'
import {parseHTML} from '@github-ui/parse-html'
import {getBaseFetchHeaders} from '@github-ui/fetch-headers'

function disableRestoreButton(parent: Element) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const button = parent.querySelector<HTMLButtonElement>('form>button')!
  button.disabled = true

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const summary = parent.querySelector<HTMLElement>('summary')!
  summary.classList.add('disabled')

  for (const detail of parent.querySelectorAll('details')) {
    detail.removeAttribute('open')
  }
}

function restoreStatus(parent: Element, html: DocumentFragment) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const container = parent.querySelector<HTMLElement>('.js-restore-status')!
  container.textContent = ''
  container.append(html)
}

on('submit', '.js-repo-restore', async function (event) {
  const form = event.currentTarget as HTMLFormElement
  event.preventDefault()
  let response
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const parent = form.closest<HTMLElement>('.js-deleted-repository')!
  try {
    response = await fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: {
        Accept: 'text/html',
        ...getBaseFetchHeaders(),
      },
    })
  } catch {
    // Ignore network errors
  }
  if (!response || !response.ok) return
  const html = parseHTML(document, await response.text())
  restoreStatus(parent, html)
})

observe('.js-restore-repo-job', function (el) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const parent = el.closest<HTMLElement>('.js-deleted-repository')!
  disableRestoreButton(parent)
})

on('click', '.js-disableable-summary.disabled', e => e.preventDefault())
